import _ from 'lodash';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import HFMDragDropContext from '../hfm-drag-drop-context';

const filterSelectedSongs = (selectedSongs = [], songList) => {
	return songList.filter((song) => {
		return selectedSongs.map(({ id }) => id).indexOf(song.id) === -1;
	});
};

const SongListItem = ({ id, title, artistName, onClick, icon }) => {
	return (
		<div className="grid-x align-middle" data-ta="songListItem">
			<div className="cell shrink">
				<button
					type="button"
					data-id={ id }
					data-ta="addSongBtn"
					onClick={ onClick }
					style={{
						textAlign: 'left'
					}}
					className="button secondary clear expanded margin-bottom-0">
						<span
							className={ `icon fi-${icon}` }
							style={{
								margin: '0.5rem 0',
								float: 'left'
							}}>
						</span>
				</button>
			</div>
			<div className="cell auto">
				{ title }
				<br />
				<em>{ artistName }</em>
			</div>
		</div>
	);
};

@inject('artistStore')
@observer
class SongList extends Component {
	// Normally you would want to split things out into separate components.
	// But in this example everything is just done in one place for simplicity
	render() {
		const { artistStore } = this.props;
		const { songList, selectedSongs } = this.props;
		const songs = filterSelectedSongs(selectedSongs, songList);

		return (
			<div className="grid-x album-form-song-list">
				<div className="cell small-6">
					<h5>Song List</h5>
					<div className="dnd-song-list" data-ta="songList">
						{
							songs.map(({ id, title, artistID }) => (
								<SongListItem
									key={ id }
									id={ id }
									title={ title }
									icon="plus"
									onClick={ this.addSong }
									artistName={ this.getArtistName(artistID) } />
							))
						}
					</div>
				</div>

				<div className="cell small-6" data-ta="selectedSongs">
					<h5>Selected Songs</h5>
					<HFMDragDropContext
						dragDropList={ selectedSongs }
						onDragEnd={ this.props.onDragEnd }
						ItemLabel={ this.renderLabel }
						ItemButton={ this.renderRemoveButton } />
				</div>
			</div>
		);
	}

	@autobind
	addSong (e) {
		const { addSong } = this.props;
		const id = e.currentTarget?.dataset?.id;
		if (_.isNil(id) || id === '') {

			return;
		}
		addSong(id);
	}

	@autobind
	removeSong (e) {
		const { removeSong } = this.props;
		const id = e.currentTarget?.dataset?.id;
		if (_.isNil(id) || id === '') {

			return;
		}
		removeSong(id);
	}

	@autobind
	renderRemoveButton ({ id }) {
		return (
			<button
				type="button"
				key={ id }
				data-id={ id }
				onClick={ this.removeSong }
				className="button secondary clear margin-bottom-0">
					<span className="icon fi-minus"></span>
			</button>
		);
	}

	@autobind
	renderLabel ({ title, artistID }) {
		return (
			<div>
				{ title }
				<br />
				<em>{ this.getArtistName(artistID) }</em>
			</div>
		);
	}

	getArtistName (artistID) {
		const { artistStore } = this.props;
		const artist = artistStore.getArtistByID(artistID);
		return _.isObject(artist) ? (<em>{ artist.name }</em>) : '--';
	}
}

export default SongList;
